import axios, {
    // AxiosRequestConfig, AxiosTransformer
} from 'axios';
import AppLocale from '../shared/localization';
import { GOOGLE_API_KEY } from 'shared/constants/AppConst';
// import { AuthService } from './Auth';
// import {AuthService} from './Auth';


export const StorageKeyForJWT: string = 'hp_jwt';
export const StorageKeyForRefreshToken: string = 'refreshToken';

const HPServerInstance = axios.create({
    // baseURL: "http://10.194.10.191:4000/api/", //YOUR_API_URL HERE
    baseURL: "https://homeprivatepartnersbedev.azurewebsites.net/api/", //YOUR_API_URL HERE
    //baseURL: 'https://homeprivatebeprod.azurewebsites.net/api/', //YOUR_API_URL HERE
    headers: {
        'Content-Type': 'application/json',
    },
});

export const KoalyErogazioneServerInstance = axios.create({
    baseURL: "https://koalyerogazionebe.azurewebsites.net/api/",
    headers: {
        'Content-Type': 'application/json',
    },
});

export const HPGoogleMapsInstance = axios.create({
    baseURL: "https://maps.googleapis.com/maps/api/",
    params: {
        key: GOOGLE_API_KEY
    },
    headers: {
        'Content-Type': 'application/json',
    },
});

export const HPGoogleAddressValidationInstance = axios.create({
    baseURL: "https://addressvalidation.googleapis.com/",
    params: {
        key: GOOGLE_API_KEY
    },
    headers: {
        'Content-Type': 'application/json',
    },
});

export const NominatimServerInstance = axios.create({
    baseURL: 'https://nominatim.openstreetmap.org/',
    headers: {
        'Content-Type': 'application/json',
    },
})

export const HPServerPartnersInstance = axios.create({
    baseURL: 'https://homeprivatepartnersbedev.azurewebsites.net/api/', //YOUR_API_URL HERE
    //baseURL: 'https://homeprivatebedev.azurewebsites.net/api/', //YOUR_API_URL HERE
    //baseURL: 'https://homeprivatebeprod.azurewebsites.net/api/', //YOUR_API_URL HERE
    headers: {
        'Content-Type': 'application/json',
    },
});

export const setLanguageHeader = (lang: keyof typeof AppLocale = "it") => {
    if (lang) {
        HPServerInstance.defaults.headers.common['Accept-Language'] = lang;
    }
};

export const setJWT = (token: string) => {
    if (token) {
        HPServerInstance.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        KoalyErogazioneServerInstance.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        localStorage.setItem(StorageKeyForJWT, token);
    } else {
        removeJWT()
    }
};


export const removeJWT = () => {
    // AuthService().logout();
    delete HPServerInstance.defaults.headers.common['Authorization'];
    delete KoalyErogazioneServerInstance.defaults.headers.common['Authorization'];
    localStorage.removeItem(StorageKeyForJWT);
};


export const setRefreshToken = (token: string) => {
    if (token) {
        localStorage.setItem(StorageKeyForRefreshToken, token);
    }
};


export const removeRefreshToken = () => {
    localStorage.removeItem(StorageKeyForRefreshToken);
};

export default HPServerInstance;

export const HttpStatus = {
    UNAUTHORIZED: 401,
    FORBIDDEN: 403,
    INTERNAL_SERVER_ERROR: 500,
};

export const handleJWTExpiration = async <ServiceType, ResultType, InputType>(service: ServiceType, methodName: keyof ServiceType, input: InputType) => {
    // @ts-ignore
    let call: (input: InputType) => Promise<ResultType> = service[methodName];
    let refreshToken = localStorage.getItem(StorageKeyForRefreshToken);
    let accessToken = localStorage.getItem(StorageKeyForJWT);
    if(!refreshToken || !accessToken){
        throw new Error();
    }
    try {
        //AuthService().refreshToken()
        let result = await call(input);
        return result;
    } catch (e) {
        throw new Error();
    }
};
